<script setup lang="ts">
useDefaultMeta({
  title: 'Undelivery KiriminAja - Cegah Retur Sebelum Terjadi!',
  description:
    'Tahu lebih dulu saat paket gagal kirim! Dapatkan notifikasi real-time, ambil tindakan cepat, dan jaga reputasi toko dengan Undelivery KiriminAja.',
  robots: 'index, follow'
})

const faqs = [
  {
    question: 'Apa itu fitur Undelivery KiriminAja?',
    answer:
      'Fitur monitoring real-time yang memberi notifikasi otomatis ketika paket gagal kirim - karena alamat tidak valid, penerima tidak ada, atau kendala kurir di lapangan.'
  },
  {
    question: 'Apakah Undelivery bisa digunakan di semua ekspedisi?',
    answer:
      'Ya. Undelivery memantau status pengiriman dari semua ekspedisi yang terintegrasi di sistem KiriminAja.'
  },
  {
    question: 'Apakah bisa langsung action dari dashboard?',
    answer:
      'Bisa. Kamu dapat melakukan konfirmasi alamat, follow-up pembeli, atau proses kirim ulang tanpa keluar dari dashboard.'
  },
  {
    question: 'Apakah fitur ini berbayar?',
    answer:
      'Tidak. Fitur Undelivery otomatis aktif dan gratis untuk semua pengguna dashboard KiriminAja.'
  },
  {
    question: 'Apa manfaat terbesar dari Undelivery?',
    answer:
      'Meningkatkan kecepatan respon ke pelanggan, mengurangi angka retur, dan menjaga reputasi bisnismu tetap solid.'
  }
]
</script>

<template>
  <div class="flex flex-col">
    <HeroBase
      title="Jangan Tunggu Pembeli Komplain, Tahu Lebih Dulu Saat Paket Gagal Kirim"
      sub-title="Sistem Undelivery"
      description="Fitur Undelivery KiriminAja memberi notifikasi otomatis dan solusi cepat setiap kali ada kendala di lapangan. Cegah retur, jaga reputasi, dan pastikan pelanggan tetap puas."
      hero-image="/images/undelivery-banner-1.webp"
      button-label="Gunakan Sekarang"
      :button-link="
        $utm.utmUrl('/login', {
          redirectTo: '/undelivery'
        })
      "
    />

    <KeunggulanUndeliverySection1 />
    <KeunggulanUndeliverySection2 />
    <KeunggulanUndeliverySection3 />
    <FaqBase :faqs="faqs" />
    <KeunggulanUndeliveryCta />
  </div>
</template>
